import jwtDecode from "jwt-decode";
import { Navigate, BrowserRouter, Route, Routes } from "react-router-dom";
import { authenticatedRoutes } from "./config/routesConfig";
// layouts
import DashboardLayout from "./layouts/DashboardLayout";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ForgotPasswordSubmit from "./pages/auth/ForgotPasswordSubmit";
//
import Login from "./pages/auth/Login";
import { getRole, getToken } from "./services/authService";
import PrivacyPolicy from "./pages/auth/PrivacyPolicy";

export default function AppRoutes() {
  const token = getToken();
  const userRole = getRole();

  const isAuthenticated = () => {
    if (token && jwtDecode(token)["exp"] * 1000 >= Date.now()) {
      return true;
    }
  };

  return (
    <BrowserRouter basename="/">
      <Routes>
        {isAuthenticated() && (
          <>
            <Route path="impex" element={<DashboardLayout />}>
              {console.log(userRole, "Hello there")}
              {authenticatedRoutes.map((route) => {
                if (route.accessorsRole.includes(userRole)) {
                  return (
                    <Route
                      key={route.pathName}
                      path={route.pathName}
                      element={route.view}
                    />
                  );
                }
                return null;
              })}
            </Route>
            <Route
              path="*"
              element={<Navigate to={"/impex/dashboard"} replace />}
            />
          </>
        )}
        {!isAuthenticated() && (
          <>
            <Route path="" element={<Login />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route
              path="forgot-password-submit/:email"
              element={<ForgotPasswordSubmit />}
            />
            <Route path="*" element={<Navigate to={"/"} replace />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}
